//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import emptyCell from "../components/emptyCell";
import BottomNav from "../components/BottomNav";
import CertificateBox from "../components/certificateBox";

export default {
    name: "welfareNotice",
    components: {emptyCell, CertificateBox},
    data() {
        return {
            list: [],
            loading: false,
            member: {}
        }
    },
    methods: {
        getCoupons(mId) {
            var page = {
                maxResultCount: 30,
                skipCount: 0,
                status: 0,
                channelType: 0,
                memberId: mId
            };
            this.loading = true
            abp.ajax.post('/api/services/app/Birthday/SearchBirthdayNotices', page).then(res => {
                this.list = [];
                this.list.push(...res.data.result.items);
            }).finally(() => {
                this.loading = false
            })
        },
        async getMyMember() {
            var vm = this;
            await this.$store.dispatch({
                type: 'member/getMyMember'
            }).then(() => {
                vm.member = {};
                vm.member = vm.$store.state.member.memberInfo;
                localStorage.setItem('MemberId', vm.member.id);
                if (vm.member && parseInt(vm.member.id) > 0) {
                    this.getCoupons(parseInt(vm.member.id))
                }

            });
        },
    },
    created() {
        this.getMyMember();
    }
}
